export const inventoryAggregations = `
aggregations {
  subject {
    key
    count
  }
  grade {
    key
    count
  }
  dok {
    key
    count
  }
  blooms {
    key
    count
  }
  interaction {
    key
    count
  }
}
`;

export const searchPassagesAggregations = `
aggregations {
  alignmentIds {
    key
    count
  }
  contextIds {
    key
    count
  }
}
`;

export const defaultAggregations = `
  aggregations {
    bankId {
      key
      count
    }
    grade {
      key
      count
    }
    subject {
      key
      count
    }
    blooms {
      key
      count
    }
    dok {
      key
      count
    }
    fileExtension {
      key
      count
    }
    fileMimetype {
      key
      count
    }
    language {
      key
      count
    }
    interaction {
      key
      count
    }
    keywords {
      key
      count
    }
    maturity {
      key
      count
    }
    objectiveAuthority {
      key
      count
    }
    objectiveId {
      key
      count
    }
    objectiveScope {
      key
      count
    }
    objectiveAbbreviation {
      key
      count
    }
    type {
      key
      count
    }
    alignmentIds {
      key
      count
    }
    tagsKey {
      key
      count
    }
    tagsValue {
      key
      count
    }
    tagsKeyValue {
      key
      count
    }
    workspaceId {
      key
      count
    }
  }
  total
`;
